import { render, staticRenderFns } from "./SubsetsPSPTransactionsReport.vue?vue&type=template&id=edc146e0"
import script from "./SubsetsPSPTransactionsReport.vue?vue&type=script&lang=js"
export * from "./SubsetsPSPTransactionsReport.vue?vue&type=script&lang=js"
import style0 from "./SubsetsPSPTransactionsReport.vue?vue&type=style&index=0&id=edc146e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports